/**
 * engineeringStandards — chave ÚNICA da exibição dos Engineering Standards na interface.
 *
 * Decisão do dono (2026-10-06): a auditoria dos 11 Engineering Standards está desligada na
 * plataforma (`COMPLIANCE_DETERMINISTIC_PASS=true` — o passo grava tudo como `skipped`) e
 * ele vai pensar em outra alternativa. Até lá, nada sobre os standards aparece na
 * interface: aba, KPI, cartões, selos e textos ficam ocultos.
 *
 * Nada foi apagado: o backend, a tabela `compliance_checks` e os componentes seguem no
 * código. Para voltar a mostrar tudo, basta `true` aqui.
 */
export const MOSTRAR_ENGINEERING_STANDARDS = false;
